module.exports = __webpack_public_path__ + "images/complex-icon-68c119fc793dff3c331fa42563d74d81.svg";